import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { CTAButton } from './CTAButtons';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Services & Pricing',
    href: '/services'
  }, {
    name: 'FAQ',
    href: '/faq'
  }, {
    name: 'Contact',
    href: '/contact'
  }, {
    name: "T&C's",
    href: '/terms'
  }];
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="flex justify-between items-center py-4" data-id="element-139">
          <Logo data-id="element-140" />
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-141">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`text-sm font-medium transition-colors ${location.pathname === item.href ? 'text-red-700' : 'text-gray-700 hover:text-red-700'}`} data-id="element-142">
                {item.name}
              </Link>)}
          </nav>
          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-3" data-id="element-143">
            <CTAButton type="whatsapp" onClick={() => window.open('https://wa.me/YOURPHONENUMBER', '_blank')} data-id="element-144" />
            <CTAButton type="telegram" onClick={() => window.open('https://t.me/YOURUSERNAME', '_blank')} data-id="element-145" />
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-146">
            <button type="button" className="bg-white p-2 rounded-md text-gray-800" onClick={toggleMenu} data-id="element-147">
              <span className="sr-only" data-id="element-148">Open main menu</span>
              {isMenuOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-149" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-150" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-151">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-152">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === item.href ? 'text-red-700 bg-gray-50' : 'text-gray-700 hover:text-red-700 hover:bg-gray-50'}`} onClick={() => setIsMenuOpen(false)} data-id="element-153">
                {item.name}
              </Link>)}
            <div className="flex flex-col space-y-2 pt-2" data-id="element-154">
              <CTAButton type="whatsapp" onClick={() => window.open('https://wa.me/YOURPHONENUMBER', '_blank')} data-id="element-155" />
              <CTAButton type="telegram" onClick={() => window.open('https://t.me/YOURUSERNAME', '_blank')} data-id="element-156" />
            </div>
          </div>
        </div>}
    </header>;
};